import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from 'react-router-dom';
import './Styles/App.css';
import styles from './Styles/App.module.css';
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';

import { UsersProvider, useUsers } from "./Commoncontext/UsersContext";
import { SelectedCompanyProvider } from './Commoncontext/SelectedCompanyContext';
import { CompanyProvider } from './Commoncontext/CompanyContext';
import { CompanyConfigProvider } from './Commoncontext/CompanyConfigContext';
import { ServicerequestsProvider } from './Commoncontext/ServicerequestsContext';
import { DocumentsProvider } from './Commoncontext/DocumentsContext';
import { AnnouncementsProvider } from './Commoncontext/AnnouncementsContext';
import { VarauskalenteritProvider } from './Commoncontext/VarauskalenteritContext';
import { ReservationsProvider } from "./Commoncontext/ReservationsContext";
import { VarauskalenteritRaportointiProvider } from './Commoncontext/VarauskalenteritRaportointiContext';
import { ToastProvider } from './Commoncontext/ToastContext';

import MobileNavigation from './Components/MobileNavigation';
import MobileDrawerMenu from './Components/MobileDrawerMenu';
import Frontpage from './pages/Frontpage';
import ReservationsNew from './pages/ReservationsNew';
import CalendarsAdmin from './pages/CalendarsAdmin';
import Reporting from './pages/Reporting';
import Settings from './pages/Settings';
import ActivityLogs from './pages/ActivityLogs';
import Baseinformation from './pages/Baseinformation';
import Portalconfig from './pages/Portalconfig';
import Meters from './pages/Meters';
import Servicerequests from './pages/Servicerequests';
import Chatbot from './pages/Chatbot';
import Header from './Components/Header';
import Sidebar from './Components/Sidebar';
import Users from './pages/Users';
import UsersApi from "./Api/UsersApi";
import Owninformation from './pages/Owninformation';
import ChangePassword from './pages/ChangePassword';
import Announcements from './pages/Announcements';
import Documents from './pages/Documents';
import Announcementnew2 from './pages/Announcementnew2';
import Consent from './pages/Consent';
import SignupInvite from './pages/SignupInvite';
import SessionTimeout from './Components/SessionTimeout';
import logo from './Images/logooranssi.png';
import useResponsive from './hooks/useResponsive';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [showResetForm, setShowResetForm] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoginError('');
    setResetMessage('');

    try {
      await signInWithEmailAndPassword(auth, username, password);
      navigate('/frontpage');
    } catch (error) {
      console.error("Kirjautumisvirhe:", error);
      switch (error.code) {
        case "auth/user-disabled":
          setLoginError("Tämä käyttäjätili on poistettu käytöstä.");
          break;
        default:
          setLoginError("Virheellinen käyttäjätunnus tai salasana");
      }
    }
  };

  const handlePasswordReset = async (event) => {
    event.preventDefault();
    setLoginError('');
    setResetMessage('');

    try {
      const result = await UsersApi.sendPasswordResetEmail(username);
      if (result) {
        setResetMessage("Palautuslinkki on lähetetty sähköpostiisi.");
      } else {
        setResetMessage("Palautuslinkin lähetys epäonnistui.");
      }
    } catch (error) {
      console.error("Resetointivirhe:", error);
      setResetMessage("Virhe lähetettäessä palautuslinkkiä.");
    }
  };

  return (
    <div className={styles.loginPage}>
      <div
        className={styles.loginBackgroundLogo}
        style={{ backgroundImage: `url(${logo})` }}
      />

      <div className={styles.brandCorner}>
        <div className={styles.logoRow}>
          <img src={logo} alt="AsukasHuudi logo" className={styles.brandLogo} />
          <div className={styles.brandName}>AsukasHuudi</div>
        </div>
        <div className={styles.slogan}>"Talonyhtiösi älykäs avustaja"</div>
      </div>

      <div className={styles.loginCenter}>
        <div className={styles.loginCard}>
          <h1 className={styles.loginTitle}>Tervetuloa AsukasHuudiin</h1>

          <form
            className={styles.loginForm}
            onSubmit={showResetForm ? handlePasswordReset : handleLogin}
          >
            <div className={styles.fieldGroup}>
              <label htmlFor="username" className={styles.fieldLabel}>
                Sähköpostiosoite
              </label>
              <div className={styles.inputWrapper}>
                <span className={styles.inputIcon} aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                    <path
                      d="M4 7.5L10.94 12.35C11.58 12.8 12.42 12.8 13.06 12.35L20 7.5"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="3.25"
                      y="5.25"
                      width="17.5"
                      height="13.5"
                      rx="3"
                      stroke="currentColor"
                      strokeWidth="1.7"
                    />
                  </svg>
                </span>
                <input
                  id="username"
                  type="email"
                  className={styles.loginInput}
                  placeholder="Anna sähköpostiosoitteesi"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>

            {!showResetForm && (
              <div className={styles.fieldGroup}>
                <label htmlFor="password" className={styles.fieldLabel}>
                  Salasana
                </label>
                <div className={styles.inputWrapper}>
                  <span className={styles.inputIcon} aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                      <rect
                        x="5.25"
                        y="10.25"
                        width="13.5"
                        height="9.5"
                        rx="2.75"
                        stroke="currentColor"
                        strokeWidth="1.7"
                      />
                      <path
                        d="M8 10V7.75C8 5.68 9.68 4 11.75 4H12.25C14.32 4 16 5.68 16 7.75V10"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                  <input
                    id="password"
                    type="password"
                    className={styles.loginInput}
                    placeholder="Anna salasanasi"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>
            )}

            <div className={styles.loginActions}>
              {!showResetForm ? (
                <span
                  className={styles.resetLink}
                  onClick={() => {
                    setShowResetForm(true);
                    setLoginError('');
                    setResetMessage('');
                  }}
                >
                  Unohtuiko salasana?
                </span>
              ) : (
                <span
                  className={styles.resetLink}
                  onClick={() => {
                    setShowResetForm(false);
                    setResetMessage('');
                    setLoginError('');
                  }}
                >
                  &lt; Sisään kirjautumaan
                </span>
              )}
            </div>

            <div className={styles.buttonContainer}>
              <button type="submit" className={styles.loginButton}>
                {showResetForm ? "Lähetä palautuslinkki" : "Kirjaudu sisään"}
              </button>
            </div>

            {loginError && <div className={styles.loginError}>{loginError}</div>}
            {resetMessage && <div className={styles.loginMessage}>{resetMessage}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}

function AppContent() {
  const { user } = useUsers();
  const { isCompactShell } = useResponsive();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleTimeout = async () => {
    await signOut(auth);
    localStorage.removeItem("users_cache_etag_v1");
    localStorage.removeItem("sr_cache_etag_v1");
    localStorage.removeItem("ann_cache_etag_v2");
    localStorage.removeItem("documents_cache_etag_v1");
    window.location.href = "/login";
  };

  const closeMobileMenu = () => setIsMobileMenuOpen(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);

  if (!isCompactShell && isMobileMenuOpen) {
    setTimeout(() => setIsMobileMenuOpen(false), 0);
  }

  return (
    <SelectedCompanyProvider>
      <CompanyProvider>
        <CompanyConfigProvider>
          <DocumentsProvider>
            <ServicerequestsProvider>
              <AnnouncementsProvider>
                <VarauskalenteritRaportointiProvider>
                  <VarauskalenteritProvider>
                    <ReservationsProvider>
                      <Router>
                        <div className={styles.container}>
                          {user && !isCompactShell && <Header />}

                          {user && isCompactShell && (
                            <MobileNavigation onMenuClick={toggleMobileMenu} />
                          )}

                          {user && isCompactShell && isMobileMenuOpen && (
                            <MobileDrawerMenu onClose={closeMobileMenu} />
                          )}

                          <div className={styles.body}>
                            {user && !isCompactShell && <Sidebar />}
                            {user && <SessionTimeout onTimeout={handleTimeout} />}

                            <Routes>
                              <Route
                                path="/login"
                                element={user ? <Navigate replace to="/frontpage" /> : <Login />}
                              />
                              <Route
                                path="/"
                                element={user ? <Frontpage /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/frontpage"
                                element={user ? <Frontpage /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/reservationsnew/:calendarSlug"
                                element={user ? <ReservationsNew /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/reservationsnew"
                                element={user ? <ReservationsNew /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/reporting"
                                element={user ? <Reporting /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/settings/calendars-admin"
                                element={user ? <CalendarsAdmin /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/settings/meters"
                                element={user ? <Meters /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/settings"
                                element={user ? <Settings /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/settings/baseinformation"
                                element={user ? <Baseinformation /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/settings/portalconfig"
                                element={user ? <Portalconfig /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/announcements"
                                element={user ? <Announcements /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/announcementnew2"
                                element={user ? <Announcementnew2 /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/announcementnew2/:id"
                                element={user ? <Announcementnew2 /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/documents"
                                element={user ? <Documents /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/servicerequests"
                                element={user ? <Servicerequests /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/settings/users"
                                element={user ? <Users /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/settings/activitylogs"
                                element={user ? <ActivityLogs /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/owninformation"
                                element={user ? <Owninformation /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/owninformation/:id"
                                element={user ? <Owninformation /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/consent"
                                element={user ? <Consent /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/chatbot"
                                element={user ? <Chatbot /> : <Navigate replace to="/login" />}
                              />
                              <Route
                                path="/change-password"
                                element={user ? <ChangePassword /> : <Navigate replace to="/login" />}
                              />
                              <Route path="/signup" element={<SignupInvite />} />
                            </Routes>
                          </div>
                        </div>
                      </Router>
                    </ReservationsProvider>
                  </VarauskalenteritProvider>
                </VarauskalenteritRaportointiProvider>
              </AnnouncementsProvider>
            </ServicerequestsProvider>
          </DocumentsProvider>
        </CompanyConfigProvider>
      </CompanyProvider>
    </SelectedCompanyProvider>
  );
}

function App() {
  return (
    <UsersProvider>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </UsersProvider>
  );
}

export default App;